import { InjectionToken } from '@angular/core';

/**
 * @description    Returns # of days between 2 given dates
 * @param dateObj  Date object
 * @param dateObj2 Second Date Object
 */
export const getDaysBetweenDates = (dateObj: Date, dateObj2: Date): number => {
    const startDate = new Date(dateObj);
    startDate.setHours(0,0,0,0);

    const endDate = new Date(dateObj2);
    endDate.setHours(0,0,0,0);

    const dateDifference = startDate.getTime() - endDate.getTime();

    return Math.ceil(dateDifference / (1000 * 3600 * 24));
};

export type GetDaysBetweenDatesProvider = (dateObj: Date, dateObj2: Date) => number;
export const GET_DAYS_BETWEEN_DATES =
    new InjectionToken('GET_DAYS_BETWEEN_DATES', {
        factory: () => getDaysBetweenDates
    });
